import { render, staticRenderFns } from "./searchBtodNew.vue?vue&type=template&id=a2e669b4"
import script from "./searchBtodNew.vue?vue&type=script&lang=js"
export * from "./searchBtodNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports